import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { EnvironmentConfig } from '../config/environment.config';
import { ISurveySettings } from '../models/settings/survey-settings.interface';

@Injectable({
  providedIn: 'root'
})
export class ResearchSettingsService {
  constructor(
    @Inject('environment') private environment: EnvironmentConfig,
    private http: HttpClient
  ) {}

  saveResearchSettings(projectId: string, methodId: string, settings: ISurveySettings): Observable<boolean> {
    return this.http.put<boolean>(`${this.environment.endPoint}project/${projectId}/research/${methodId}/research/settings`, settings);
  }
}
